import { enableProdMode, importProvidersFrom, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core'

import { environment } from './environments/environment'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { AuthInterceptor } from './app/interceptors/auth-interceptor'
import { ErrorInterceptor } from './app/interceptors/error-interceptor'
import { LambdaInterceptor } from './app/interceptors/lambda-interceptor'
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { ToastrModule } from 'ngx-toastr'
import { OAuthModule } from 'angular-oauth2-oidc'
import { AppComponent } from './app/app.component'
import { provideRouter } from '@angular/router'
import { routes } from './app/app.routes'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'

if (environment.production) {
    enableProdMode()
}

ModuleRegistry.registerModules([AllCommunityModule])

bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),
        importProvidersFrom(
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            NgbModule,
            ToastrModule.forRoot(),
            OAuthModule.forRoot({
                resourceServer: {
                    allowedUrls: [environment.baseUrl],
                    sendAccessToken: false,
                },
            }),
        ),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LambdaInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'fr' },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideRouter(routes),
    ],
}).catch((err) => console.error(err))
